import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import posthog from 'posthog-js'
import useSetAddBulletin from './hooks/useSetAddBulletin'
import { getBulletinReach } from 'services/fund'
import { faPlain } from 'utilities/helper/format'

interface IModalProps {
    show: boolean
    onHide: () => void
    title?: string
    refetch: () => void
    /** the fund being posted to */
    moneyPool: string | undefined
}

/**
 * A new post on the fund's board. Publishing reaches every member (round 2):
 * the sheet says how many, on what, before the manager presses تایید.
 */
export default function AddBulletinModal({
    show,
    onHide,
    refetch,
    moneyPool,
}: IModalProps) {
    const [value, setValue] = useState<string>('')
    const [sendSms, setSendSms] = useState(false)
    const { mutate } = useSetAddBulletin(refetch)
    const { data: reach } = useQuery(
        ['bulletin-reach', moneyPool],
        () => getBulletinReach(moneyPool as string),
        { enabled: show && !!moneyPool }
    )

    const handleSubmit = () => {
        if (!moneyPool || !value.trim()) return
        mutate({ id: moneyPool, text: value, sendSms })
        posthog.capture('bulletin_posted', {
            fund_id: Number(moneyPool),
            send_sms: sendSms,
            reach_total: reach?.total ?? null,
            reach_messenger: reach?.messenger ?? null,
        })
        setValue('')
        setSendSms(false)
        onHide()
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" my-1">متن اعلام مورد نظر را بنویسید:</p>
                <p>(حداکثر پانصد حرف)</p>
                <hr className=" my-2" />
                <textarea
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="متن اعلام صندوق را در این قسمت بنویسید..."
                    className=" h-32 w-full outline-none text-center"
                />
                <hr className=" my-2" />
                {reach ? (
                    <div
                        className="mx-3 mb-2 rounded-lg bg-brand-soft p-3 text-right leading-6 text-text-body"
                        data-testid="bulletin-reach"
                    >
                        <p>
                            📣 با انتشار، این اعلان برای همهٔ{' '}
                            {faPlain.format(reach.total)} عضو صندوق فرستاده
                            می‌شود: {faPlain.format(reach.messenger)} نفر در بله
                            یا ایتا
                            {reach.app_only
                                ? `، و ${faPlain.format(
                                      reach.app_only
                                  )} نفر فقط به‌صورت اعلان و پیام داخل همیان.`
                                : '.'}
                        </p>
                        {reach.sms_available && reach.sms_count > 0 && (
                            <label className="mt-2 flex items-start gap-2">
                                <input
                                    type="checkbox"
                                    checked={sendSms}
                                    onChange={(e) =>
                                        setSendSms(e.target.checked)
                                    }
                                    className="mt-1"
                                />
                                <span>
                                    برای {faPlain.format(reach.sms_count)} عضوی
                                    که در بله/ایتا نیستند پیامک هم برود (
                                    {faPlain.format(reach.sms_count)} پیامک از
                                    بستهٔ صندوق)
                                </span>
                            </label>
                        )}
                        {reach.app_only > 0 && (
                            <p className="mt-2 text-text-secondary">
                                اعضایی که در بله/ایتا باشند اعلان را همان لحظه و
                                رایگان می‌گیرند.{' '}
                                <Link
                                    to={`/fund/invite/${moneyPool}`}
                                    className="font-bold text-brand"
                                    onClick={onHide}
                                >
                                    لینک دعوت به بله/ایتا را بفرستید
                                </Link>
                            </p>
                        )}
                    </div>
                ) : null}
                <button
                    className=" text-xs text-current"
                    form="authProfile"
                    onClick={handleSubmit}
                >
                    انتشار برای همهٔ اعضا
                </button>
                <hr className=" my-2" />
                <p className=" text-xs cursor-pointer" onClick={onHide}>
                    انصراف
                </p>
            </div>
        </Modal>
    )
}
